<template>
    <v-label :config="configTooltip">
        <v-tag :config="tagConfig" />
        <v-text :config="textConfig" />
    </v-label>
</template>

<script>
import { GRID_SIZE } from '../utils/editor.constants';

export default {
    props: {
        toolTipParameters: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            showLabel: false,
        };
    },

    computed: {
        configTooltip() {
            if (!this.toolTipParameters) return {};

            const defaultParameters = {
                width: this.toolTipWidth,
                opacity: this.showLabel ? 1 : 0,
            };

            if (this.toolTipParameters?.isIcon) {
                return {
                    ...defaultParameters,
                    x: this.offsetX - 100,
                    y: this.offsetY - 50,
                };
            }

            return {
                ...defaultParameters,
                x: -(this.toolTipWidth / 2) + (GRID_SIZE / 2) + this.offsetX,
                y: -40 + this.offsetY,
            };
        },

        offsetX() {
            return this.toolTipParameters?.offsetX || 0;
        },

        offsetY() {
            return this.toolTipParameters?.offsetY || 0;
        },

        toolTipText() {
            return this.$t(this.toolTipParameters?.toolTipText);
        },

        toolTipWidth() {
            return ((this.toolTipText?.length || 0) + 5) * 6.25;
        },

        tagConfig() {
            return {
                fill: '#2C2C2C',
                lineJoin: 'round',
                cornerRadius: 8,
            };
        },

        textConfig() {
            if (!this.toolTipParameters?.toolTipText) return {};

            return {
                text: this.toolTipText,
                fontFamily: 'Sul Sans',
                fontSize: 12,
                width: this.toolTipWidth,
                align: 'center',
                lineHeight: 1.4,
                draggable: false,
                padding: 10,
                fill: 'white',
            };
        },

    },

    watch: {
        toolTipParameters: {
            deep: true,
            handler(val) {
                if (!val || !val.toolTipText) {
                    this.showLabel = false;
                } else {
                    this.showLabel = true;
                }
            },
        },
    },

};
</script>
